module.exports = __webpack_public_path__ + "static/product-mobile-f8198668147b2546ec6291e6fecb9b96.jpg";